import { Box, Typography } from '@mui/material';
import { formatDateTime } from '../utils';
import Links from '../components/widgets/Links';

function StepContent({ step, getConnectedNotes }) {
  return (
    <Box>
      {step.endDate && (
        <Typography variant="body2" sx={{ mb: 1 }}>
          Ends {formatDateTime(step.endDate)}
        </Typography>
      )}
      {step.description && <Typography sx={{ mb: 1 }}>{step.description}</Typography>}
      {step.host && (
        <Typography variant="body2" sx={{ mb: 1 }}>
          Host: {step.host}
        </Typography>
      )}
      {step.links?.length > 0 && (
        <Box sx={{ mt: 1 }}>
          <Links links={step.links} />
        </Box>
      )}
      {getConnectedNotes(step)}
    </Box>
  );
}

export default StepContent;
